const removeSlashs = (path) => {
    return path.replace(/^\//, '').replace(/\/$/, '');
};
export const matchPath = (url, path) => {
    return removeSlashs(url).startsWith(removeSlashs(path));
};
//# sourceMappingURL=match-path.js.map